<template>
    <header class="Header">
        <video v-if="state.appLoaded" disableRemotePlayback disablePictureInPicture x-webkit-airplay="deny" muted playsinline ref="video_logo" src="/img/cut_logo.mp4"/>
    </header>
</template>

<script>

import Store from '@/stores/store.js'

export default {
    name: 'Header',
    props: {
        msg: String
    },
    data() {
        return {
            state: Store.state
        }
    },
    methods: {
        goToState(state) {
            if(state === 0) {
                //Reset the video to start  
                this.$refs.currentTime = 0
            }
            else if(state === 1) {
                //Plays the video until the middle
                this.$refs.video_logo.play() 
                this.$refs.video_logo.addEventListener('timeupdate', this.handleEventState1)


            }
            else if (state === 2) {
                //Plays the video from middle to end 
                this.$refs.video_logo.play() 
                this.$refs.video_logo.addEventListener('timeupdate', this.handleEventState2)
            }
        },
        handleEventState1() {
                if(this.$refs.video_logo.currentTime > this.$refs.video_logo.duration/2) {
                        this.$refs.video_logo.pause() 
                        this.$refs.video_logo.currentTime = this.$refs.video_logo.duration/2
                        this.$refs.video_logo.removeEventListener("timeupdate", this.handleEventState1);   
                        if(this.absoluteState !== 0) {
                            this.goToState(2)
                        }
                        
                                             
                }
        },
        handleEventState2() {
                if(this.$refs.video_logo.currentTime === this.$refs.video_logo.duration) {
                        this.$refs.video_logo.pause() 
                        this.$refs.video_logo.currentTime = 0
                        this.$refs.video_logo.removeEventListener("timeupdate", this.handleEventState2);
                }
        }   
    },

    mounted(){
        if(!Store.isDesktop){
            if( !this.state.isDesktop && this.$route.name !== 'home' ){
                TweenMax.set(this.$el, { x: (Store.width - 80) /2 });
            }else{
                TweenMax.set(this.$el, { x: 0});
            }
        }

        if(this.$route.name === 'home') {
            setTimeout(() => {
                this.goToState(1)
            }, 1250);
        }
        else {
            //this.goToState(2)
            setTimeout(() => {
                this.goToState(2)
            }, 2500);
        }

    },

    computed:{
        isRight: function(){
            return !this.state.isDesktop && this.$route.name !== 'home';
        },
        absoluteState(){
            return this.state.level;
        },
    },

    watch: {
        isRight: function(val){
            if(!Store.isDesktop){
                if( val ){
                    TweenMax.to(this.$el, .6, { x: (Store.width - 80) /2, ease: Power3.easeOut });
                }else{
                    TweenMax.to(this.$el, .6, { x: 0, ease: Power3.easeOut });
                }
            }
        },
        absoluteState: function(newVal, oldVal){
             if(newVal === 0 && oldVal !== 0 ) {
                this.goToState(1)
             }
             else if(oldVal === 0) {
                 this.goToState(2)
            }
        },
    },
}
</script>


<style scoped lang="scss">
    .Header{
        position: fixed;
        top: 70px;
        left: 90px;

        z-index: zindex(header);

        mix-blend-mode: difference;
        
        @include respond-to(md){
            top: 0;
            left: 20px;
        }

        img{
            width: 155px;
            height: 69px;
        }

        video {
            width: 155px;
            height: 69px;
        }
    }

    .isTouch {
        .Header {
            top: 0;
            left: 20px;
        }
    }
</style>
